import React from "react";
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  description?: string;
  center?: boolean;
  inverse?: boolean;
};
export function SectionHeading({
  eyebrow,
  title,
  description,
  center = false,
  inverse = false
}: SectionHeadingProps) {
  return <div className={`${center ? "mx-auto text-center" : ""} max-w-3xl`} data-id="element-308" data-mp="3k06sdhx8u5sg">
      {eyebrow && <p className="mb-4 text-xs font-extrabold tracking-[0.14em] text-[#0077e8]" data-id="element-309" data-mp="3k2025635l64o">{eyebrow}</p>}
      <h2 className={`text-3xl font-extrabold leading-[1.1] tracking-[-0.055em] sm:text-4xl lg:text-5xl ${inverse ? "text-white" : "text-[#091a37]"}`} data-id="element-310" data-mp="bmpulighv8pi">{title}</h2>
      {description && <p className={`mt-5 text-base leading-7 sm:text-lg ${inverse ? "text-[#b5c7e0]" : "text-[#526078]"}`} data-id="element-311" data-mp="1uacml576k4m">{description}</p>}
    </div>;
}